<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Reguł pracy</span>
        <h3 class="page-title">Lista reguł pracy pracowników</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button theme="success"
                  @click.prevent="$router.push('/reguly/dodaj')">
          <i class="material-icons">add</i>
          Dodaj regułę
        </d-button>
      </d-col>
    </d-row>
    <d-row
      v-if="loaded"
      style="width: 100%;"
      class="d-flex ml-0 mb-3 page-filters">
      <validation-observer
        ref="rules-filters-form"
        tag="form"
        style="width: 100%;"
        class="d-flex">
        <d-input
          placeholder="Podaj nazwę reguły"
          v-model="filters.search" />
        <d-select
                class="ml-2"
                placeholder="status reguły"
                :reduce="status => status.value"
                v-model="filters.active"
                :options="statuses" />
        <d-select
                class="ml-2"
                placeholder="sortuj po"
                :reduce="order => order.value"
                v-model="filters.order_column"
                :options="orders" />
        <d-select
                class="ml-2"
                placeholder="kierunek sortowania"
                :reduce="direction => direction.value"
                v-model="filters.order_direction"
                :options="directions" />
        <d-button
          theme="info"
          outline
          class="text-nowrap ml-2"
          @click.prevent="validateFiltersForm">Szukaj</d-button>
        <d-button
          theme="danger"
          outline
          class="text-nowrap ml-2"
          @click.prevent="clearFilters">Resetuj filtry</d-button>
      </validation-observer>
    </d-row>

    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
        <tr>
          <th scope="col" @click="sort('user_name')" class="border-0">Imię</th>
          <th scope="col" @click="sort('name')" class="border-0">Przedział ważności reguły</th>
          <th scope="col" @click="sort('name')" class="border-0">Status</th>
          <th scope="col" class="border-0">Akcje</th>
        </tr>
        </thead>
        <tbody v-if="loaded">
        <tr
          v-for="(rule, index) of rules"
          :key="'rule-' + index">
          <td class="align-middle">
            {{ rule.user_name }}
          </td>
          <td class="align-middle">
            {{rule.start_rule.slice(0, 10)}} - {{rule.end_rule.slice(0, 10)}}
          </td>
          <td class="align-middle">
            <span :class="rule.status_id === 'before' ? 'text-primary' : ( rule.status_id === 'active' ? 'text-success' : 'text-danger')">
              {{rule.status}}
            </span>
          </td>
          <td
            class="align-middle"
            style="width: 150px;">
            <d-button
              theme="primary"
              @click.prevent="$router.push('/reguly/edycja/' + rule.id)"
              class="mr-2"
              title="Edytuj">
              <i class="material-icons">edit</i>
            </d-button>
            <d-button
              theme="danger"
              :disabled="removeInProgress"
              @click.prevent="removeRule(rule.id)"
              title="Usuń">
              <i class="material-icons">delete</i>
            </d-button>
          </td>
        </tr>
        <tr v-if="rules.length === 0">
          <td
            colspan="5"
            class="text-center">
            Brak reguł do wyświetlenia&hellip;
          </td>
        </tr>
        </tbody>
      </table>

      <div v-if="!loaded" class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>
    </d-card>

    <pagination :meta-data="paginationMetaData" />
  </d-container>
</template>
<script>
import debounce from 'lodash.debounce';
import FormUtils from './../utils/FormUtils.js';
import HasFilters from './../mixins/HasFilters.vue';
import HasPagination from './../mixins/HasPagination.vue';
import ListUtils from './../utils/ListUtils.js';
import Pagination from './../components/common/Pagination.vue';

export default {
  name: 'work-rules',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    'pagination': Pagination
  },
  computed: {
  },
  data() {
    return {
      rules: [],
      loaded: false,
      loadError: false,
      removeInProgress: false,
      statuses: [
        {
          value: 'all',
          text: 'wszystkie statusy'
        },
        {
          value: 'before',
          text: 'będzie aktywna'
        },
        {
          value: 'after',
          text: 'była aktywna'
        },
        {
          value: 'current',
          text: 'jest aktywna'
        }
      ],
      orders: [
        {
          value: 'id',
          text: 'sortuj domyślnie',
        },
        {
          value: 'name',
          text: 'imię',
        },
        {
          value: 'last_name',
          text: 'nazwisko',
        },
        {
          value: 'start_rule',
          text: 'reguła od',
        },
        {
          value: 'end_rule',
          text: 'reguła do',
        }
      ],
      directions: [
        {
          value: 'ASC',
          text: 'rosnąco',
        },
        {
          value: 'DESC',
          text: 'malejąco'
        }
      ],
      filters: {
        search: '',
        user_id: '',
        active: 'all',
        order_column: 'id',
        order_direction: 'ASC'
      }
    };
  },
  mounted () {
    this.loadFilteredData();
  },
  methods: {
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadFilteredData();
    }, 250),
    loadFilteredData () {
      let where = {
        search: this.filters.search,
        user_id: this.filters.user_id,
        active: this.filters.active,
        order_column: this.filters.order_column,
        order_direction: this.filters.order_direction
      };

      ListUtils.loadItemsData(this, {
        endpoint: '/rules/list',
        listField: 'rules',
        pagination: true,
        params: {
          where
        }
      });
    },
    clearFilters () {
      this.loaded = false;
      this.loadError = false;
      this.filters = {
        search: '',
      };

      this.loadFilteredData();
      this.$bus.$emit('view-filters-reset');
    },
    validateFiltersForm () {
      this.$bus.$emit('pagination-reset');
      FormUtils.validate(this.$refs['rules-filters-form'], this.debouncedLoadFilteredData);
    },
    removeRule (rulesID) {
      this.removeInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/rules/delete/',
        id: rulesID,
        successTitle: 'Usunięto regułę',
        successText: 'Wybrana reguła została usunięta',
        confirmTitle: 'Czy na pewno chcesz usunąć tą regułę?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie reguły nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>
